"use client";

import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
  Avatar,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import {
  ArrowBack,
  ThumbUp,
  Comment,
  Visibility,
  Send,
  Bookmark 
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router";
import { useCallback, useEffect, useState } from "react";
import { apiRemote, IForumInfo, ITopicInfo } from "@/api";
import { marked } from "marked";
import moment from "moment";
import { useUser } from "@/contexts/UserContext";
import { useAlert } from "@/contexts/AlertContext";
import { StyledLink } from "@/components/StyledLink";
import { Users } from "lucide-react";
import { Pagination } from "@mui/material";
// import { useRouter } from "next/navigation"


export default function ForumDetail() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const alert = useAlert();
  const [forumInfo, setForumInfo] = useState<IForumInfo["data"]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(3);
  const [totalPages, setTotalPages] = useState(1);

  const { user } = useUser();

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    apiRemote
      .getDetailForum(id, page, perPage)
      .then((data) => {
        setForumInfo(data["data"]);
        setTotalPages(data["total_pages"] || 1);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [id, page, perPage]);

  return (
    <Box sx={{ width: "100%", mx: "auto" }}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate("../../dashboard")}
        sx={{ mb: 3 }}
        variant="outlined"
      >
        Back to Dashboard
      </Button>

      {/* Main Content */}
      <Card sx={{ mb: 4 }}>
        {loading ? (
          <Box
            sx={{
              p: 3,
              bgcolor: "white",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CardContent>
            <Stack spacing={3}>
              {forumInfo.map((item, index) => (
                <Box key={index}>
                  <StyledLink to={`/${process.env.PREFIX}/forum/discussion/${item.id}`}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {item.title}
                    </Typography>
                  </StyledLink>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">
                      by {item.author?.name}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography variant="body2">👍 {item.total_favourite}</Typography>
                      <Typography variant="body2">
                        💬{" "}
                        {Number(item.total_reply)}
                      </Typography>
                      <Typography variant="body2">📌 {item.total_subscibe}</Typography>
                    </Box>
                  </Box>
                  {index < forumInfo.length - 1 && (
                    <Box
                      sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}
                    />
                  )}
                </Box>
              ))}
            </Stack>
          </CardContent>
        )}
      </Card>
      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Pagination
            count={totalPages} // Tổng số trang
            page={page} // Trang hiện tại
            onChange={(event, value) => setPage(value)} // Cập nhật trang khi bấm
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
}
